import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType } from 'vue'
import { AlignmentLineAxis } from '@/types/edit'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlignmentLine',
  props: {
  type: {
    type: String as PropType<'vertical' | 'horizontal'>,
    required: true,
  },
  axis: {
    type: Object as PropType<AlignmentLineAxis>,
    required: true,
  },
  length: {
    type: Number,
    required: true,
  },
  canvasScale: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props



// 吸附对齐线的位置
const left = computed(() => props.axis.x * props.canvasScale + 'px')
const top = computed(() => props.axis.y * props.canvasScale + 'px')

// 吸附对齐线的长度
const sizeStyle = computed(() => {
  if (props.type === 'vertical') return { height: props.length * props.canvasScale + 'px' }
  return { width: props.length * props.canvasScale + 'px' }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "alignment-line",
    style: _normalizeStyle({ left: _unref(left), top: _unref(top) })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['line', __props.type]),
      style: _normalizeStyle(_unref(sizeStyle))
    }, null, 6)
  ], 4))
}
}

})